module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst projectTermJobMode = config.projectTermJobMode || false\nconst fieldConfig = model.config || {}\nlet disabled = false\nif(!!formMapping && !!formMapping.fieldConfig) {\ndisabled = !!formMapping.fieldConfig.disabled\n}\nconst additionalClasses = []\nif(disabled) \t\t\t\tadditionalClasses.push('disabled');\nif(fieldConfig.isHidden) \tadditionalClasses.push('isHidden');\nlet buttonType = 'assign';\nif(fieldConfig.buttonType) buttonType = fieldConfig.buttonType;\nlet buttonContext = 'nrOfElementsPerJob';\nif(fieldConfig.buttonContext) buttonContext = fieldConfig.buttonContext;\n%><div class=\"<%- (additionalClasses.join(' ')) %>\" data-field-code=\"<%= model.fieldCode %>\"><%\n%><section class=\"top\"><%\nif(fieldConfig.additionalTopTitle) {\n%><div class=\"topTitle\"><%= storage.__(fieldConfig.additionalTopTitle) %></div><%\n}\nif(projectTermJobMode) {\n%><%- include('../elements/buttons/default', { formMapping: { buttonType: 'showList', context: 'projectTermJobs' } }); %><%\n} else {\n%><%- include('../elements/buttons/default', { formMapping: { buttonType, context: buttonContext, positive: fieldConfig.buttonPositive, negative: fieldConfig.buttonNegative } }); %><%\nif(fieldConfig.supportDeleteSelection){\n%><%- include('../elements/buttons/default', { formMapping: { buttonType, context: buttonContext, mode: 'empty', symbolOnly: true } }); %><%\n}\n}\n%></section><%\nif(fieldConfig.showSummary) {\n%><div class=\"summary\"><%\n%><%- (model.summaryOfAssignedElements || []).map(v => `<div class=\"element\">${v}</div>`).join('')\n%></div><%\n}\n%></div>"
  , __filename = "components/templates/core/form/fields/selectNrOfElementsPerJobPickerButton.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const projectTermJobMode = config.projectTermJobMode || false
const fieldConfig = model.config || {}
let disabled = false
if(!!formMapping && !!formMapping.fieldConfig) {
disabled = !!formMapping.fieldConfig.disabled
}
const additionalClasses = []
if(disabled) 				additionalClasses.push('disabled');
if(fieldConfig.isHidden) 	additionalClasses.push('isHidden');
let buttonType = 'assign';
if(fieldConfig.buttonType) buttonType = fieldConfig.buttonType;
let buttonContext = 'nrOfElementsPerJob';
if(fieldConfig.buttonContext) buttonContext = fieldConfig.buttonContext;

    ; __line = 15
    ; __append("<div class=\"")
    ; __append( (additionalClasses.join(' ')) )
    ; __append("\" data-field-code=\"")
    ; __append(escapeFn( model.fieldCode ))
    ; __append("\">")
    ; 

    ; __line = 16
    ; __append("<section class=\"top\">")
    ; 
if(fieldConfig.additionalTopTitle) {

    ; __line = 18
    ; __append("<div class=\"topTitle\">")
    ; __append(escapeFn( storage.__(fieldConfig.additionalTopTitle) ))
    ; __append("</div>")
    ; 
}
if(projectTermJobMode) {

    ; __line = 21
    ; __append( include('../elements/buttons/default', { formMapping: { buttonType: 'showList', context: 'projectTermJobs' } }) )
    ; 
} else {

    ; __line = 23
    ; __append( include('../elements/buttons/default', { formMapping: { buttonType, context: buttonContext, positive: fieldConfig.buttonPositive, negative: fieldConfig.buttonNegative } }) )
    ; 
if(fieldConfig.supportDeleteSelection){

    ; __line = 25
    ; __append( include('../elements/buttons/default', { formMapping: { buttonType, context: buttonContext, mode: 'empty', symbolOnly: true } }) )
    ; 
}
}

    ; __line = 28
    ; __append("</section>")
    ; 
if(fieldConfig.showSummary) {

    ; __line = 30
    ; __append("<div class=\"summary\">")
    ; 

    ; __line = 31
    ; __append( (model.summaryOfAssignedElements || []).map(v => `<div class="element">${v}</div>`).join('')
)
    ; __line = 32
    ; __append("</div>")
    ; 
}

    ; __line = 34
    ; __append("</div>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/core/form/fields/selectNrOfElementsPerJobPickerButton.ejs

}